











































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../components/nav-left.vue";
import { ZuzhijiagouList } from "@/request/yonghuquanxian";
import {
  GetTemplatesOfGroup,
  GetTopicsOfTemplate,
  GetDataExportTemplates,
  PostDataExport,
} from "@/request/zhuanbingshujuku";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav,
    SelectMultiSearch,
  },
})
export default class ZbsjkDataExport extends Vue {
  private project: any = {};
  private group: any = {};
  private institutions: any[] = [];
  private creators: any[] = [];
  private filters: any = {
    表格名称: "",
    institution_id: "",
    institution_ids: [],
    性别: "",
    最低年龄: 0,
    最高年龄: 150,
    姓名身份: "",
    开始时间: "",
    结束时间: "",
    时间段: "",
    条件: "全部条件",
    行研究指标: [],
    列研究指标: [],
    timeWay: "全部",
    time: [],
    ageWay: "全部",
    export_answer_code: false,
  };
  private ifAllHospital: any = false;
  private searchedTemplates: any[] = [];
  private rightTemplatesGroup: any[] = [];
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList(text) {
    const params: any = {
      params: {
        search: text,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = data;
    });
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["行研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(
      this,
      this.project.project_id,
      this.group.group_id
    ).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 获得右侧可选的模板列表
   */
  private fetchRightTemplates() {
    const loading = this.$loading({ target: ".addExportTable" });
    const params: any = {
      params: {
        group_id: this.group.group_id,
      },
    };
    GetDataExportTemplates(this, params)
      .then((data: any) => {
        data.map((item: any) => {
          item.opened = false;
          item.choice = false;
        });
        if (data.length > 0) {
          data[0].opened = true;
        }

        this.rightTemplatesGroup = data;
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["行研究指标"].splice(index, 1);
  }

  /**
   * @description 全选或取消全选
   */
  private triggerAll(value) {
    this.rightTemplatesGroup.forEach((tGroup: any) => {
      tGroup["choice"] = value;
      tGroup["templates"].forEach((template: any) => {
        template["choice"] = value;
      });
    });
  }

  /**
   * @description 外层选中变化
   */
  private tGroupChange(value, tGroup) {
    console.log(value);
    console.log(tGroup);
    if (value === true) {
      this.rightTemplatesGroup.forEach((tgroup: any) => {
        tgroup["choice"] = false;
        tgroup["templates"].forEach((template: any) => {
          template["choice"] = false;
        });
      });
    }
    tGroup["choice"] = value;
    tGroup["templates"].forEach((template: any) => {
      template["choice"] = value;
    });
  }

  /**
   * @description 里层选中变化
   */
  private templateChange(value, tGroup, t) {
    this.rightTemplatesGroup.forEach((tgroup: any) => {
      if (
        tGroup["project_id"] !== tgroup["project_id"] &&
        tGroup["zhenci"] !== tgroup["zhenci"]
      ) {
        tgroup["choice"] = false;
        tgroup["templates"].forEach((template: any) => {
          template["choice"] = false;
        });
      }
    });
    if (value === true) {
      let allSelect = true;
      tGroup["templates"].forEach((template: any) => {
        if (!template["choice"]) {
          allSelect = false;
        }
      });
      tGroup["choice"] = allSelect;
    } else {
      tGroup["choice"] = false;
    }
    t["choice"] = value;
  }

  /**
   * @description 导出
   */
  private startExport() {
    if (!this.filters["表格名称"]) {
      this.$message.warning("表格名称不能为空");
      return;
    }
    if (!this.filters.institution_id) {
      this.$message.warning("请选择要导出的所属层级");
      return;
    }
    this.filters["列研究指标"] = this.rightTemplatesGroup;
    const params: any = {
      表格名称: this.filters["表格名称"],
      project_id: this.project.project_id,
      institution_id: this.filters.institution_id,
      user_ids: this.filters.user_ids,
      姓名身份: this.filters["姓名身份"],
      条件: this.filters["条件"],
      列研究指标: this.filters["列研究指标"],
      export_answer_code: this.filters["export_answer_code"],
    };
    // 创建时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
    }
    // 年龄时间段
    if (this.filters.ageWay === "自定义") {
      params["最低年龄"] = this.filters["最低年龄"];
      params["最高年龄"] = this.filters["最高年龄"];
    }
    if (this.filters["行研究指标"].length > 0) {
      const arr: any[] = [];
      this.filters["行研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["行研究指标"] = arr;
    }
    const loading = this.$loading({
      lock: true,
      text: "导出中",
      spinner: "el-icon-loading",
    });
    PostDataExport(this, params).then((data: any) => {
      // window.open(
      //   window.API_ROOT + "api/wajue/download?filename=" + data.file_name
      // );
      loading.close();
      if (data.error_code !== 0) {
        this.$message({
          type: "error",
          message: data.msg,
        });
      } else {
        this.$message.success(
          "导出成功，可至导出中心查看数据。备注：需要导出到本地的，可至导出中心下载"
        );
      }
    });
  }

  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.project_id || !this.$route.query.group_id) {
      this.$message.error("参数有误，请稍等后重新操作");
      this.$router.back();
      return;
    }
    this.project.project_id = this.$route.query.project_id;
    this.group.group_id = this.$route.query.group_id;
    this.getZuzhijiagouList(" ");
    this.fetchTemplates();
    this.fetchRightTemplates();
  }
}
